"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOpenTemplateModal = exports.setSelectedTemplate = exports.updateSavingMethod = exports.updatePermission = exports.updateTemplateName = exports.selectSavingMethod = exports.closeTemplate = exports.templateSlice = exports.getPermissionTemplate = exports.updateTemplate = exports.saveTemplate = exports.initialTemplateModalState = void 0;
const pulse_components_1 = require("@pcs/pulse-components");
const toolkit_1 = require("@reduxjs/toolkit");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const notification_1 = __importDefault(require("../../../reviews/constants/notification"));
const helper_1 = require("../../../reviews/helper");
const constants_1 = require("./constants");
exports.initialTemplateModalState = {
    savingMethod: null,
    templateName: '',
    isValidTemplateName: true,
    usersView: [],
    officesView: [],
    brandCategoriesView: [],
    brandsView: [],
    usersEdit: [],
    selectedTemplate: null,
    openApplyTemplateModal: false,
};
const TEMPLATE_URL = `${helper_1.URLS.app}api/workflow-templates`;
exports.saveTemplate = (0, toolkit_1.createAsyncThunk)('template/saveTemplate', async (template) => {
    await pulse_components_1.v2Endpoint.request({
        method: pulse_components_1.METHODS.POST,
        url: `${helper_1.URLS.app}api/workflow-templates`,
        data: template,
        headers: {
            'Content-type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
        },
    });
});
exports.updateTemplate = (0, toolkit_1.createAsyncThunk)('template/updateTemplate', async ({ id, template }) => {
    await pulse_components_1.v2Endpoint.request({
        method: pulse_components_1.METHODS.PATCH,
        url: `${TEMPLATE_URL}/${id}`,
        data: template,
        headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
        },
    });
});
exports.getPermissionTemplate = (0, toolkit_1.createAsyncThunk)('template/getPermissionTemplats', async (templateId) => {
    const response = await pulse_components_1.v2Endpoint
        .get(`${TEMPLATE_URL}/${templateId}`)
        .then((res) => {
        const { data } = res;
        const template = (0, utilities_1.camelizeKeys)((0, utilities_1.parseJsonApi)(data));
        return template;
    });
    return response;
});
exports.templateSlice = (0, toolkit_1.createSlice)({
    name: 'template',
    initialState: exports.initialTemplateModalState,
    reducers: {
        closeTemplate: () => exports.initialTemplateModalState,
        selectSavingMethod: (state, action) => {
            state.savingMethod = action.payload;
            // clear template setting
            if (action.payload === 'saveAsNew') {
                state.selectedTemplate = null;
                state.brandCategoriesView = [];
                state.brandsView = [];
                state.officesView = [];
                state.usersEdit = [];
                state.usersView = [];
                state.selectedTemplate = null;
                state.templateName = '';
            }
        },
        updateTemplateName: (state, action) => {
            state.templateName = action.payload;
            state.isValidTemplateName = !!action.payload;
        },
        updatePermission: (state, action) => {
            switch (action.payload.permissionType) {
                case constants_1.PERMISSION_TYPE.brandView:
                    state.brandsView = action.payload.value;
                    break;
                case constants_1.PERMISSION_TYPE.officeView:
                    state.officesView = action.payload.value;
                    break;
                case constants_1.PERMISSION_TYPE.userView:
                    state.usersView = action.payload.value;
                    break;
                case constants_1.PERMISSION_TYPE.userEdit:
                    state.usersEdit = action.payload.value;
                    break;
                case constants_1.PERMISSION_TYPE.brandCategoriesView:
                    state.brandCategoriesView = action.payload.value;
                    break;
                default:
                    break;
            }
        },
        updateSavingMethod: (state, action) => {
            state.savingMethod = action.payload;
        },
        setSelectedTemplate: (state, action) => {
            state.selectedTemplate = action.payload;
        },
        setOpenTemplateModal: (state, action) => {
            state.openApplyTemplateModal = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(exports.saveTemplate.pending, () => {
            utilities_1.default.blockPage();
        })
            .addCase(exports.saveTemplate.fulfilled, () => {
            utilities_1.default.unblockPage();
            utilities_1.default.notification.success(notification_1.default.savedTemplate);
        })
            .addCase(exports.saveTemplate.rejected, () => {
            utilities_1.default.unblockPage();
            utilities_1.default.notification.danger(notification_1.default.saveTemplateFailed);
        })
            .addCase(exports.getPermissionTemplate.fulfilled, (state, action) => {
            const userView = [];
            const userEdit = [];
            const brandView = [];
            const brandCategoryView = [];
            const officeView = [];
            action.payload.permissions.forEach((permission) => {
                if (permission.resourceType === constants_1.TEMPLATE_RESOURCE.user &&
                    permission.permission === constants_1.TEMPLATE_PERMISSION.view) {
                    userView.push({
                        value: `${permission.resourceId}`,
                        label: permission.resourceName,
                    });
                }
                if (permission.resourceType === constants_1.TEMPLATE_RESOURCE.user &&
                    permission.permission === constants_1.TEMPLATE_PERMISSION.edit) {
                    userEdit.push({
                        value: `${permission.resourceId}`,
                        label: permission.resourceName,
                    });
                }
                if (permission.resourceType === constants_1.TEMPLATE_RESOURCE.brand &&
                    permission.permission === constants_1.TEMPLATE_PERMISSION.view) {
                    brandView.push({
                        value: `${permission.resourceId}`,
                        label: permission.resourceName,
                    });
                }
                if (permission.resourceType === constants_1.TEMPLATE_RESOURCE.brandCategory &&
                    permission.permission === constants_1.TEMPLATE_PERMISSION.view) {
                    brandCategoryView.push({
                        value: `${permission.resourceId}`,
                        label: permission.resourceName,
                    });
                }
                if (permission.resourceType === constants_1.TEMPLATE_RESOURCE.client &&
                    permission.permission === constants_1.TEMPLATE_PERMISSION.view) {
                    officeView.push({
                        value: `${permission.resourceId}`,
                        label: permission.resourceName,
                    });
                }
            });
            state.usersView = userView;
            state.usersEdit = userEdit;
            state.brandsView = brandView;
            state.brandCategoriesView = brandCategoryView;
            state.officesView = officeView;
            state.templateName = action.payload.name;
            state.isValidTemplateName = !!action.payload.name;
        })
            .addCase(exports.getPermissionTemplate.rejected, () => {
            utilities_1.default.notification.danger(notification_1.default.loadTemplatePermissionFailed);
        })
            .addCase(exports.updateTemplate.pending, () => {
            utilities_1.default.blockPage();
        })
            .addCase(exports.updateTemplate.fulfilled, () => {
            utilities_1.default.unblockPage();
            utilities_1.default.notification.success(notification_1.default.updatedTemplatePermission);
        })
            .addCase(exports.updateTemplate.rejected, () => {
            utilities_1.default.unblockPage();
            utilities_1.default.notification.danger(notification_1.default.updateTemplatePermissionFailed);
        });
    },
});
_a = exports.templateSlice.actions, exports.closeTemplate = _a.closeTemplate, exports.selectSavingMethod = _a.selectSavingMethod, exports.updateTemplateName = _a.updateTemplateName, exports.updatePermission = _a.updatePermission, exports.updateSavingMethod = _a.updateSavingMethod, exports.setSelectedTemplate = _a.setSelectedTemplate, exports.setOpenTemplateModal = _a.setOpenTemplateModal;
exports.default = exports.templateSlice.reducer;
